export default {
  namespaced: true,
  state: {
    loading: false,
    loadingPercentage: 0
  },
  mutations: {
    setLoading (state, flag) {
      state.loading = flag
    },
    setLoadingPercentage (state, percentage) {
      state.loadingPercentage = percentage
    }
  },
  actions: {
    setLoading ({commit}, data) {
      commit('setLoading', data.loading)
      commit('setLoadingPercentage', data.percentage)
    },
    done ({commit}) {
      setTimeout(() => {
        commit('setLoading', false)
        commit('setLoadingPercentage', 0)
      }, 1500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loading-indicator.js